import React from 'react';
import { FiUser } from 'react-icons/fi';
import { formatPercent, isEmpty } from './format';
import styles from './styles.module.css';

/* Карточка профиля (п. 2 ТЗ): сведения из личного дела, в режиме правки
   не изменяются. Слева фотография во всю высоту карточки, под ней личный
   номер и пол; справа ФИО, показатель заполнения личного дела и сведения
   в две колонки. Незаполненное значение — курсивом «не указано». */

const Value = ({ children }) => (
  isEmpty(children)
    ? <span className={`${styles.v} ${styles.none}`}>не указано</span>
    : <span className={styles.v}>{children}</span>
);

const joinNames = (list, key) => {
  if (!Array.isArray(list) || !list.length) return null;
  const names = list.map((item) => item && item[key]).filter((name) => !isEmpty(name));
  return names.length ? names.join(', ') : null;
};

/* Состав сведений одинаков для любой категории (штатный, переменный состав,
   иностранный гражданин и т.д.) — так и в макете, и в описании метода
   GET /users/{id}: должности и их подразделения приходят полями
   teacherDetails.Position/Podr и combining независимо от категории.
   Учебная группа, курс и форма обучения в шапке портфолио не показываются —
   это отдельно оговорено в описании метода. */
const buildItems = (user) => {
  const teacher = user.teacherDetails || {};
  return [
    ['Категория', user.categor],
    ['Воинское звание', user.militaryrank],
    ['Гражданство', user.country],
    ['Основная должность', teacher.Position],
    ['Подразделение основной должности', teacher.Podr],
    ['Подразделение должности по совмещению', joinNames(teacher.combining, 'depname')],
    ['Адрес фактического проживания', user.address],
    ['Контактный телефон', user['Phone home']],
    ['Мобильный телефон', user['Phone cell']],
    ['Электронная почта', user.EMail],
  ];
};

const ProfileCard = ({ user, photo }) => {
  const percent = formatPercent(user.completeness);
  const fio = [user.lastname, user.firstname, user.patronymic].filter((part) => !isEmpty(part)).join(' ');
  const hasPhoto = !!photo && user.photosize !== 0;

  return (
    <section className={styles.prof}>
      <div className={styles.photo}>
        {hasPhoto
          ? <img src={photo} alt="Фотография" />
          : <div className={styles.photoNone} title="Фотография не загружена"><FiUser size={56} /></div>}
        <div className={styles.cap}>
          <div>Личный номер: {isEmpty(user.number) ? <i>не указан</i> : <b>{user.number}</b>}</div>
          <div>Пол: {isEmpty(user.sex) ? <i>не указан</i> : <b>{user.sex}</b>}</div>
        </div>
      </div>

      <div className={styles.profMain}>
        <div className={styles.fio}>{fio || <span className={styles.none}>не указано</span>}</div>

        <div className={styles.fill}>
          <div className={styles.fillLine}>
            <span>Заполнение личного дела</span>
            <b>{percent}%</b>
          </div>
          <div className={styles.bar} role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={percent}>
            <i style={{ width: `${percent}%` }} />
          </div>
        </div>

        <div className={styles.grid}>
          {buildItems(user).map(([label, value]) => (
            <div className={styles.it} key={label}>
              <span className={styles.k}>{label}</span>
              <Value>{value}</Value>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProfileCard;
